import React from 'react';
import RolePrivateRoute from 'src/components/PrivateRotes/RolePrivateRoute';
import CapitalBalanceSummaryView from './components/CapitalBalanceSummaryView';
import { ACCOUNTING_CAPITAL_BALANCE_CONFIG } from './config';

const AccountingCapitalBalanceSummaryView = () => {
  return (
    <>
      <RolePrivateRoute
        component={() => (
          <CapitalBalanceSummaryView
            config={ACCOUNTING_CAPITAL_BALANCE_CONFIG}
          />
        )}
      />
    </>
  );
};


export default AccountingCapitalBalanceSummaryView;

